import { ROUTES } from 'sharedKernel/constants'

export const getStartRoute = (permissions: string[] | undefined): string => {
  if (permissions === undefined || permissions.length === 0) {
    return getHubRoute(ROUTES.HUB.USER_CONFIG)
  }

  // Verificar se é Admin City Hall pelo company type
  const { getCredLocalStorage } = require('sharedKernel/auth/credLocalStorage')
  const companyType = getCredLocalStorage()?.company?.type
  const isAdminCityHall = permissions.includes('admin city hall') || permissions.includes('admin_city_hall') || companyType?.type === "Admin City Hall"
  const isCityHall = permissions.includes('city hall') || permissions.includes('city_hall') || companyType?.type === "City Hall"

  if (permissions.includes('caixa_employee')) {
    return getHubRoute(ROUTES.HUB.STARTUP.CHALLENGE_LIST)
  } else if (isAdminCityHall || isCityHall) {
    return getHubRoute(ROUTES.HUB.COMPANY.CITY_HALL_MAIN)
  } else if (permissions.includes('challenge')) {
    return getHubRoute(ROUTES.HUB.DASHBOARD)
  } else if (permissions.includes('idea')) {
    return getHubRoute(ROUTES.HUB.STARTUP.CHALLENGE_LIST)
  } else if (permissions.includes('evaluation')) {
    return getHubRoute(ROUTES.HUB.EVALUATOR.CHALLENGE_LIST)
  }

  return getHubRoute(ROUTES.HUB.USER_CONFIG)
}

export const getHubRoute = (targetRoute: string): string => {
  return `${ROUTES.HUB.ROOT}${targetRoute}`
}
